import BrandAuditDetailContainer from './BrandAuditDetailContainer';
export default BrandAuditDetailContainer;
